import { useEffect } from "react";

import { PAGE_SIZE_DEFAULT } from "@/constants/app.constants";
import usePagination from "@/hooks/usePagination";
import useToastError from "@/hooks/useToastError";
import { useAppDispatch, useAppSelector } from "@/redux/store";

import { getNotification } from "../../api/notification.api";
import { NotificationStatus } from "../../constants/notification.constant";
import { notificationAction } from "../../redux/notification.slice";
import NotificationComp from "./component/Notification";

const Notification = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useAppSelector((state) => state.notification);
  const { showToastError } = useToastError();
  const { pagination, setPagination } = usePagination();

  const fetchNotification = async (page: number, type: string) => {
    try {
      const result = await getNotification({
        pageNumber: page,
        pageSize: PAGE_SIZE_DEFAULT,
        notificationStatusFilter:
          type === "unread" ? NotificationStatus.UNREAD : undefined,
      });
      setPagination({
        current: page,
        size: pagination.size,
        total: result.totalPage,
      });
      if (page === 1) {
        dispatch(notificationAction.setNotification(result.data));
      } else {
        dispatch(
          notificationAction.setNotification([...notifications, ...result.data])
        );
      }
    } catch (error) {
      showToastError(error);
    }
  };

  useEffect(() => {
    fetchNotification(1, "all");
  }, []);

  return (
    <div className="pt-[100px] pb-10 h-screen bg-secondary-100 min-h-screen">
      <div className="max-w-[900px] h-full bg-white rounded-xl shadow-xl mx-auto p-10 overflow-hidden">
        <NotificationComp />
      </div>
    </div>
  );
};

export default Notification;
